import React from 'react'
import { Image } from 'utoniq-ui'

type Props = { src: string; alt: string; withBorderRadius?: boolean }
export const ThumbnailImage = ({
  src,
  alt,
  withBorderRadius = false,
}: Props) => (
  <Image
    style={{
      width: '100%',
      height: '100%',
      borderRadius: withBorderRadius ? '8px' : 'inherit',
      objectFit: 'cover',
    }}
    alt={alt}
    src={src}
  />
)
